module.exports = __webpack_public_path__ + "static/media/Crossover2.ceec95ac.jpg";